import { api } from "../lib/api";

export async function fetchTables() {
  return api.get("/api/sadt/v2/tables");
}

export async function fetchTableData(table, { limit = 100, offset = 0 } = {}) {
  const params = new URLSearchParams({ table, limit, offset });
  return api.get(`/api/sadt/v2/data?${params}`);
}

export async function upsertRow(table, payload) {
  return api.post(`/api/sadt/v2/data/${encodeURIComponent(table)}`, payload);
}

export async function deleteRow(table, rowid) {
  return api.del(`/api/sadt/v2/data/${encodeURIComponent(table)}/${rowid}`);
}
